/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.alertsModule')
.directive('bulbAlert', bulbAlert);

function bulbAlert() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/alerts/alert.html',
    transclude: true,
    scope: {
      close: '&'
    },
    link: function(scope, element, attrs){
      // Enable the closealert-animation.
      element.addClass('bulb-alert');
    }
  };
}
